/* OnHold callout: mission popup wiring, plus theme-editor slide selection. */
(function () {
  function initModal(section) {
    var dialog = section.querySelector('[data-oh-callout-modal]');
    if (!dialog || dialog.dataset.ohModalReady) return;
    dialog.dataset.ohModalReady = '1';
    section.querySelectorAll('[data-oh-callout-modal-open]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        dialog.showModal();
      });
    });
    dialog.querySelector('[data-oh-callout-modal-close]').addEventListener('click', function () {
      dialog.close();
    });
    // Click on the backdrop (the dialog element itself) closes it.
    dialog.addEventListener('click', function (event) {
      if (event.target === dialog) dialog.close();
    });
  }

  function initAllModals() {
    document.querySelectorAll('.oh-callout').forEach(initModal);
  }

  initAllModals();
  document.addEventListener('shopify:section:load', initAllModals);

  // Slides: JS takes over from the CSS keyframe loop so visitors can click
  // the left or right half, or swipe, to change photo. Autoplay pauses
  // while the photo is hovered or holds focus, and stops for good after the
  // first click or swipe, so motion can always be stopped (WCAG 2.2.2).
  var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  var SWIPE_MIN = 40;

  function initSlides(wrapper) {
    if (wrapper.ohSlides) return;
    var slides = Array.prototype.slice.call(wrapper.querySelectorAll('.oh-callout__slide'));
    var dots = wrapper.querySelectorAll('.oh-callout__dot');
    if (slides.length < 2) return;

    var seconds = parseFloat(wrapper.dataset.seconds) || 5;
    var current = 0;
    var timer = null;
    var leavingTimer = null;
    var paused = false;
    var stopped = false;
    var hovered = false;
    var focused = false;

    function schedule() {
      clearTimeout(timer);
      timer = null;
      if (paused || stopped || hovered || focused || document.hidden || reducedMotion.matches) return;
      timer = setTimeout(function () {
        goTo(current + 1);
      }, seconds * 1000);
    }

    function goTo(index) {
      var next = (index + slides.length) % slides.length;
      if (next !== current) {
        slides.forEach(function (slide) {
          slide.classList.remove('is-leaving');
        });
        slides[current].classList.remove('is-active');
        slides[current].classList.add('is-leaving');
        slides[next].classList.add('is-active');
        if (dots[current]) dots[current].classList.remove('is-active');
        if (dots[next]) dots[next].classList.add('is-active');
        var leaving = slides[current];
        clearTimeout(leavingTimer);
        leavingTimer = setTimeout(function () {
          leaving.classList.remove('is-leaving');
        }, (seconds / 5) * 1000);
        current = next;
      }
      schedule();
    }

    slides[0].classList.add('is-active');
    if (dots[0]) dots[0].classList.add('is-active');
    wrapper.classList.add('is-interactive');

    var prev = wrapper.querySelector('[data-oh-callout-prev]');
    var next = wrapper.querySelector('[data-oh-callout-next]');
    prev.hidden = false;
    next.hidden = false;

    // A mouse drag that counted as a swipe still ends in a click on one of
    // the halves; swallow that click so it doesn't move a second time.
    var startX = null;
    var startY = null;
    var swiped = false;

    prev.addEventListener('click', function () {
      if (swiped) return;
      stopped = true;
      goTo(current - 1);
    });
    next.addEventListener('click', function () {
      if (swiped) return;
      stopped = true;
      goTo(current + 1);
    });

    wrapper.addEventListener('mouseenter', function () {
      hovered = true;
      schedule();
    });
    wrapper.addEventListener('mouseleave', function () {
      hovered = false;
      schedule();
    });
    wrapper.addEventListener('focusin', function () {
      focused = true;
      schedule();
    });
    wrapper.addEventListener('focusout', function (event) {
      if (wrapper.contains(event.relatedTarget)) return;
      focused = false;
      schedule();
    });

    wrapper.addEventListener('pointerdown', function (event) {
      if (!event.isPrimary) return;
      startX = event.clientX;
      startY = event.clientY;
      swiped = false;
    });

    wrapper.addEventListener('pointerup', function (event) {
      if (startX === null) return;
      var dx = event.clientX - startX;
      var dy = event.clientY - startY;
      startX = null;
      if (Math.abs(dx) > SWIPE_MIN && Math.abs(dx) > Math.abs(dy)) {
        swiped = true;
        stopped = true;
        goTo(dx < 0 ? current + 1 : current - 1);
        setTimeout(function () {
          swiped = false;
        }, 0);
      }
    });

    wrapper.addEventListener('pointercancel', function () {
      startX = null;
    });

    wrapper.ohSlides = {
      goTo: goTo,
      indexOf: function (el) {
        return slides.indexOf(el);
      },
      pause: function () {
        paused = true;
        schedule();
      },
      resume: function () {
        paused = false;
        schedule();
      },
      refresh: schedule,
      destroy: function () {
        clearTimeout(timer);
        clearTimeout(leavingTimer);
      }
    };

    schedule();
  }

  function initAllSlides() {
    document.querySelectorAll('[data-oh-callout-slides]').forEach(initSlides);
  }

  initAllSlides();
  document.addEventListener('shopify:section:load', initAllSlides);

  document.addEventListener('shopify:section:unload', function (event) {
    event.target.querySelectorAll('[data-oh-callout-slides]').forEach(function (wrapper) {
      if (wrapper.ohSlides) wrapper.ohSlides.destroy();
    });
  });

  document.addEventListener('visibilitychange', function () {
    document.querySelectorAll('[data-oh-callout-slides]').forEach(function (wrapper) {
      if (wrapper.ohSlides) wrapper.ohSlides.refresh();
    });
  });

  function wrapperFor(target) {
    return target && target.closest ? target.closest('[data-oh-callout-slides]') : null;
  }

  // Theme editor: selecting a Photo block shows that photo and holds it.
  document.addEventListener('shopify:block:select', function (event) {
    var wrapper = wrapperFor(event.target);
    if (!wrapper || !wrapper.ohSlides) return;
    wrapper.ohSlides.pause();
    wrapper.ohSlides.goTo(wrapper.ohSlides.indexOf(event.target));
  });

  document.addEventListener('shopify:block:deselect', function (event) {
    var wrapper = wrapperFor(event.target);
    if (!wrapper || !wrapper.ohSlides) return;
    wrapper.ohSlides.resume();
  });
})();
